import { DraggableAttributes } from '@dnd-kit/core';
import { SyntheticListenerMap } from '@dnd-kit/core/dist/hooks/utilities';
import { useSortable } from '@dnd-kit/sortable';
import { CSSProperties } from 'react';

interface UseSortableItemProps {
  sortId: number | string;
  isDraggingOpacity?: number;
  disabled?: boolean;
}

export interface UseSortableItemAttributes {
  attributes: DraggableAttributes | undefined;
  listeners: SyntheticListenerMap | undefined;
  setNodeRef: (node: HTMLElement | null) => void | undefined;
  style: CSSProperties | undefined;
  isDragging: boolean;
}

export const useSortableItem = ({
  sortId,
  isDraggingOpacity = 0.5,
  disabled,
}: UseSortableItemProps): UseSortableItemAttributes => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    isDragging,
    transition,
  } = useSortable({
    id: String(sortId),
    disabled,
  });

  const style: CSSProperties = {
    transform: transform
      ? `translate(${transform.x}px, ${transform.y}px) scale(1, 1)`
      : undefined,
    transition,
    opacity: isDragging ? isDraggingOpacity : 1,
  };

  return { attributes, listeners, setNodeRef, style, isDragging };
};
